import React from "react";
import Layout from "./Layout";

const PlaceholderPage = ({ title, description }) => {
  return (
    <Layout>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "60vh",
          padding: "40px",
        }}
      >
        <div
          style={{
            fontSize: "48px",
            marginBottom: "20px",
          }}
        >
          🔒
        </div>
        <h2
          style={{
            fontSize: "24px",
            fontWeight: "600",
            color: "#17233d",
            marginBottom: "12px",
          }}
        >
          {title}
        </h2>
        <p
          style={{
            fontSize: "14px",
            color: "#808695",
            textAlign: "center",
          }}
        >
          {description || "未授权访问"}
        </p>
      </div>
    </Layout>
  );
};

export default PlaceholderPage;
